import React from 'react';
import Footer from 'components/Footer/Footer';
import './legal.css';
import { SEOHelmet, BreadcrumbList } from 'components/SEO';
import AffiliateTermsContent from './AffiliateTermsContent';

const AffiliateTerms = () => {
  return (
    <>
      <SEOHelmet
        title="Partner Program Terms & Conditions - TradeMagic"
        description="Terms and conditions for the TradeMagic Partner Program. Commission rules, payout schedule, and program policies."
        canonical="https://trademagic.gg/legal/affiliate-terms"
        type="website"
      />

      <BreadcrumbList
        breadcrumbs={[
          { name: 'Home', url: 'https://trademagic.gg' },
          {
            name: 'Partner Program Terms & Conditions',
            url: 'https://trademagic.gg/legal/affiliate-terms',
          },
        ]}
      />

      <div className="legal-wrapper">
        <div className="legal-content">
          <h1>Partner Program Terms &amp; Conditions</h1>
          <AffiliateTermsContent />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AffiliateTerms;
